import React from 'react';
import s from './Header.module.css';
import logo from '../../img/nishtyachok_logo.png'

const Header = (props) => {
    return (
        <header className={s.header}>
            <div className={s.logo}>
                <img src={logo} alt='logo'></img>
            </div>
            <div className={s.companyName}>
                <span>Нiштячок</span>
            </div>
        </header>
    )
}

export default Header;